import { BranchType, useBranchStore } from 'shared/store/branchesSlice'
import { instance } from './instance'
import { PostPathes, UpdateInterfacePayloadType } from './types'
import { useGlobalStore } from 'shared/store/globalSlice'
import { getAppName } from 'shared/helpers/getAppName'
import {
  AvailableLanguagesType,
  CCConfigType,
  DatatransType,
  MenuConfigType,
  SaferPayType,
  TableReservationConfigType
} from 'shared/store/types'

export class POST {
  public static async updateAddress(payload: Partial<BranchType>) {
    const QRMenuClientId = useBranchStore.getState().clientIdSelected
    const res: Partial<BranchType> = await instance.post(PostPathes.UPD_ADDRESS, {
      QRMenuClientId,
      ...payload
    })
    return res
  }

  public static async updateInterface(payload: Partial<UpdateInterfacePayloadType>) {
    const { branchId } = useBranchStore.getState()
    const { isCCSelected } = useGlobalStore.getState()
    const res: any = await instance.post(PostPathes.UPD_INTERFACE, {
      branchId,
      appName: getAppName(isCCSelected),
      ...payload
    })
    return res
  }

  public static async updateLanguage(language: AvailableLanguagesType | 'default') {
    const { branchId } = useBranchStore.getState()
    const { isCCSelected } = useGlobalStore.getState()
    const res: any = await instance.post(PostPathes.UPD_LANGUAGE, {
      branchId,
      appName: getAppName(isCCSelected),
      language
    })
    return res
  }

  public static async updateCCInterface(payload: Partial<CCConfigType>) {
    const res: any = await instance.post(PostPathes.UPD_CC_INTERFACE, payload)
    return res
  }

  public static async updateConfig(payload: Partial<MenuConfigType>) {
    const { branchId } = useBranchStore.getState()
    const { isCCSelected } = useGlobalStore.getState()
    const res: any = await instance.post(PostPathes.UPD_CONFIG, {
      branchId,
      appName: getAppName(isCCSelected),
      ...payload
    })
    return res
  }

  public static async updatePaymentProvider(value: 1 | 2 | 3) {
    const { branchId } = useBranchStore.getState()
    const res: any = await instance.post(PostPathes.UPD_PAYMENT, {
      paymentProviderType: value,
      paymentOnSite: false,
      branchId
    })
    return res
  }

  public static async updatePaymentOnSite(value: boolean) {
    const { branchId } = useBranchStore.getState()
    const res: any = await instance.post(PostPathes.UPD_PAYMENT, {
      paymentOnSite: value,
      branchId
    })
    return res
  }

  public static async updateDatatrans(payload: DatatransType) {
    const { branchId } = useBranchStore.getState()
    const res: any = await instance.post(PostPathes.UPD_PAYMENT, {
      paymentProviderType: 1,
      dataTrans: payload,
      branchId
    })
    return res
  }

  public static async updateSaferPay(payload: SaferPayType) {
    const { branchId } = useBranchStore.getState()
    const res: any = await instance.post(PostPathes.UPD_PAYMENT, {
      paymentProviderType: 2,
      saferPay: payload,
      branchId
    })
    return res
  }

  public static async updateHSPay(shopId: string) {
    const { branchId } = useBranchStore.getState()
    const res: any = await instance.post(PostPathes.UPD_PAYMENT, {
      paymentProviderType: 3,
      hsPay: {
        shopId
      },
      branchId
    })
    return res
  }

  public static async updateTableReservation(payload: Partial<TableReservationConfigType>) {
    const { branchId } = useBranchStore.getState()
    const res: any = await instance.post(PostPathes.UPD_TABLE_RES, {
      branchId,
      ...payload
    })
    return res
  }

  public static async encodeUrlParams(url: string, paramsToEncode: string[] = []) {
    const res: any = await instance.post(PostPathes.ENCODE_URL_PARAMS, {
      url,
      paramsToEncode
    })
    return res
  }

  public static async upsertCacheConfig(isOldCacheUsed: boolean) {
    const res: any = await instance.post(PostPathes.UPSERT_CACHE_CONFIG, { isOldCacheUsed })
    return res
  }

  public static async createNotification(payload: any) {
    const { isCCSelected } = useGlobalStore.getState()
    const res: any = await instance.post(PostPathes.SEND_NOTIFICATIONS, {
      appName: getAppName(isCCSelected),
      ...payload
    })
    return res
  }
}
